function parseEmailsLabel(emailsLabel) {
    let rcpts = [];
    let quoted = false;
    let escape = false;
    let rcpt = {
        name: '',
        email: ''
    };

    if ('string' !== typeof emailsLabel || !emailsLabel) {
        return [];
    }

    const pushRcpts = function () {
        rcpt.name = rcpt.name.trim();
        rcpt.email = rcpt.email.trim().toLowerCase();
        if (rcpt.email) {
            rcpts.push(rcpt);
        }
        rcpt = {
            name: '',
            email: ''
        };
    }

    for (let i = 0; i < emailsLabel.length; i++) {
        const chr = emailsLabel[i];
        if ('\\' === chr && quoted && !escape) {
            escape = true;
        } else if (escape) {
            rcpt.email += chr;
            escape = false;
        } else if ('"' === chr) {
            quoted = !quoted;
        } else if ('<' === chr) {
            if (quoted) {
                rcpt.email += chr;
            } else if (rcpt.email) {
                rcpt.name = rcpt.email;
                rcpt.email = '';
            }
        } else if (',' === chr || ';' === chr || '>' === chr) {
            if (quoted) {
                rcpt.email += chr;
            } else {
                quoted = false;
                pushRcpts();
            }
        } else {
            rcpt.email += chr;
        }
    }

    if (rcpt.name || rcpt.email) {
        pushRcpts();
    }

    return rcpts;
}

function toEmailsLabel(rcpts) {
    let emailsLabel = '';
    let addresses = (Array.isArray(rcpts)) ? rcpts : [rcpts];
    for (let i = 0; i < addresses.length; i++) {
        let rcpt = addresses[i];
        emailsLabel += '"' + ('' + rcpt.name).trim().replace(/\\/g, '\\\\').replace(/\"/g, '\\"')
            + '"<' + ('' + rcpt.email).trim().toLowerCase() + '>';
    }
    return emailsLabel;
}


export default {
    parseEmailsLabel,
    toEmailsLabel,
};



// WEBPACK FOOTER //
// ./src/components/core/common/EmailUtil.js